<template>
  <div class="tabs is-fullwidth">
  <ul>
    <li v-bind:class="{'is-active':(tabToShow=='personal')}">
      <a v-on:click="updateTab('personal')">
        <span class="icon is-small"><i class="fa fa-user" aria-hidden="true"></i></span>
        <span>Personal Details</span>
      </a>
    </li>
    <li v-bind:class="{'is-active':(tabToShow=='applications')}">
      <a v-on:click="updateTab('applications')">
        <span class="icon is-small"><i class="fa fa-folder-open" aria-hidden="true"></i></span>
        <span>Applications</span>
      </a>
    </li>
    <li v-bind:class="{'is-active':(tabToShow=='funding')}">
      <a v-on:click="updateTab('funding')">
        <span class="icon is-small"><i class="fa fa-thumbs-o-up" aria-hidden="true"></i></span>
        <span>Funding</span>
      </a>
    </li>
    <li v-if="1===2">
      <a>
        <span class="icon is-small"><i class="fa fa-money" aria-hidden="true"></i></span>
        <span>Donations</span>
      </a>
    </li>
    <li v-if="1===2">
      <a>
        <span class="icon is-small"><i class="fa fa-star" aria-hidden="true"></i></span>
        <span>Achievements</span>
      </a>
    </li>
    <li v-if="1===2">
      <a>
        <span class="icon is-small"><i class="fa fa-calendar" aria-hidden="true"></i></span>
        <span>Events/Volunteering</span>
      </a>
    </li>
    <li v-bind:class="{'is-active':(tabToShow=='notes')}">
      <a v-on:click="updateTab('notes')">
        <span class="icon is-small"><i class="fa fa-pencil" aria-hidden="true"></i></span>
        <span>Notes</span>
      </a>
    </li>
  </ul>
 
</div>

</template>

<script>
export default {
  data() { return {
    
   }
  },
  props: ['tabToShow'],
  methods: {
    updateTab(newTab)
    {
      this.tabToShow = newTab
      this.$emit('updateContactTab', newTab)
    }
  }
}
</script>